// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bfc_a"};